
    <mat-card class="mat-elevation-z8">
      <form [formGroup]="taluk_register_form">
        <!-- user details -->
        <div class="form-group">
          <label>Taluk Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='name'>
        </div>
        <div class="form-group">
          <label for="exampleFormControlSelect1">District</label>
          <select class="form-control dropdown_box" formControlName='district_id'>
            <option *ngFor="let district of districts" [value]="district['id']">{{district['name']}}
            </option>
          </select>
        </div>
        <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="registerTaluk()"
                [disabled]="!taluk_register_form.valid">{{action}}</button>
      </form>
    </mat-card>
